import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { MtLitterGetLitterQuery, MtLitterGetLitterQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const MT_LITTER_GET_LITTER = graphql(`
  query MtLitterGetLitter(
    $translationsWhere: LitterTranslationWhereInput!
    $dogBreedTranslationsWhere: DogBreedTranslationWhereInput!
    $where: LitterWhereInput
  ) {
    accountMe {
      id

      dogBreeder {
        id
        account {
          address {
            country
          }
        }
        litters(take: 1, where: $where) {
          id
          adminValidated
          archived
          born
          createdAt
          price
          priceFrom
          priceTo
          fixedPrice
          birthday
          availabilityDate
          description

          malesCount
          malesLeftCount
          femalesCount
          femalesLeftCount
          microchipped
          microchips
          vaccinated
          vaccinationDate
          pedigree
          pedigreeNumbers
          dewormed
          litterCode
          imgs {
            id
            small
          }

          parents {
            id
            parentType
            parentId
            parent {
              dogInfos {
                pedigreeNumber
              }
            }
          }

          translations(where: $translationsWhere) {
            id
            url
            language
          }

          dogBreed {
            id
            name
            translations(where: $dogBreedTranslationsWhere) {
              name
            }
            imgs {
              id
              small
            }
          }
        }
      }
    }
  }
`);

export const useGetLitter = (id?: number) => {
  const { language } = useRouter();

  const variables = useMemo((): MtLitterGetLitterQueryVariables => {
    return {
      where: {
        AND: [{ id: { equals: id ?? -1 } }],
      },
      dogBreedTranslationsWhere: { language: { equals: language } },
      translationsWhere: { language: { equals: language } },
    };
  }, [language, id]);

  const { data, error, loading } = useQuery<
    MtLitterGetLitterQuery,
    MtLitterGetLitterQueryVariables
  >(MT_LITTER_GET_LITTER, { variables });

  return {
    litter: data?.accountMe?.dogBreeder?.litters[0],
    breederCountry: data?.accountMe?.dogBreeder?.account?.address?.country,
    litterError: error,
    litterLoading: loading,
  };
};
